﻿/*
 * Globalize Culture hr-HR
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalize;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalize = require("globalize");
  } else {
    // Global variable
    Globalize = window.Globalize;
  }

  Globalize.addCultureInfo("hr-HR", "default", {
    name: "hr-HR",
    englishName: "Croatian (Croatia)",
    nativeName: "hrvatski (Hrvatska)",
    language: "hr",
    numberFormat: {
      pattern: ["- n"],
      ",": ".",
      ".": ",",
      percent: {
        pattern: ["-n%", "n%"],
        ",": ".",
        ".": ","
      },
      currency: {
        pattern: ["-n $", "n $"],
        ",": ".",
        ".": ",",
        symbol: "kn"
      }
    },
    calendars: {
      standard: {
        "/": ".",
        firstDay: 1,
        days: {
          names: [
            "nedjelja",
            "ponedjeljak",
            "utorak",
            "srijeda",
            "četvrtak",
            "petak",
            "subota"
          ],
          namesAbbr: ["ned", "pon", "uto", "sri", "čet", "pet", "sub"],
          namesShort: ["ne", "po", "ut", "sr", "če", "pe", "su"]
        },
        months: {
          names: [
            "siječanj",
            "veljača",
            "ožujak",
            "travanj",
            "svibanj",
            "lipanj",
            "srpanj",
            "kolovoz",
            "rujan",
            "listopad",
            "studeni",
            "prosinac",
            ""
          ],
          namesAbbr: [
            "sij",
            "vlj",
            "ožu",
            "tra",
            "svi",
            "lip",
            "srp",
            "kol",
            "ruj",
            "lis",
            "stu",
            "pro",
            ""
          ]
        },
        monthsGenitive: {
          names: [
            "siječnja",
            "veljače",
            "ožujka",
            "travnja",
            "svibnja",
            "lipnja",
            "srpnja",
            "kolovoza",
            "rujna",
            "listopada",
            "studenog",
            "prosinca",
            ""
          ],
          namesAbbr: [
            "sij",
            "vlj",
            "ožu",
            "tra",
            "svi",
            "lip",
            "srp",
            "kol",
            "ruj",
            "lis",
            "stu",
            "pro",
            ""
          ]
        },
        AM: null,
        PM: null,
        patterns: {
          d: "d.M.yyyy.",
          D: "d. MMMM yyyy.",
          t: "H:mm",
          T: "H:mm:ss",
          f: "d. MMMM yyyy. H:mm",
          F: "d. MMMM yyyy. H:mm:ss",
          M: "d. MMMM"
        }
      }
    },
    messages: {
      AdditionalHelp: "Dodatna pomoć",
      AddNewTab: "Dodaj novu karticu",
      Alerts: "Upozorenja",
      ApplyFilter: "Primijeni filtar",
      Approve: "Odobri",
      Attachments: "Privici",
      Back: "Natrag",
      Basic: "Osnovno",
      Between: "Između",
      Book: "Knjiga",
      Cancel: "Odustani",
      Checked: "Provjereno",
      ClearFilter: "Očisti filtar",
      Close: "Zatvori",
      CloseCancelChanges: "Zatvori i poništi promjene",
      CloseSaveChanges: "Zatvori i spremi promjene",
      CloseTab: "Zatvori karticu",
      ColumnPersonalization: "Personalizacija stupca",
      Comments: "Komentari",
      Confirmation: "Potvrda",
      Contains: "Sadrži",
      CreateTab: "Stvori novu karticu",
      Cut: "Izreži",
      Delete: "Izbriši",
      DiscardUndo: "Odbaci/poništi",
      DisplayDropDownList: "Prikaži padajući popis",
      Displaying: "Prikazivanje: ",
      DocWord: "Dokument",
      DoesNotContain: "Ne sadrži",
      DoesNotEndWith: "Ne završava sa",
      DoesNotEqual: "Nije jednako",
      DoesNotStartWith: "Ne započinje sa",
      Download: "Preuzmi",
      Duplicate: "Dupliciraj",
      Edit: "Uredi",
      EitherSelectedorNotSelected: "Odabrano ili nije odabrano",
      Email: "E-pošta",
      EndsWith: "Završava sa",
      EqualsStr: "Jednako je",
      ExpandCollapse: "Proširi/sažmi",
      ExportFailed: "Izvoz nije uspio",
      ExportToExcel: "Izvezi u Excel",
      FileInUse: "Navedena je datoteka u upotrebi",
      FileInUseDetail:
        "Zatvorite datoteku u aplikaciji u kojoj se upotrebljava ili odredite drugi naziv datoteke.",
      Filter: "Filtar",
      FilterMenu: "Izbornik filtra",
      FilterOptions: "Mogućnosti filtra",
      FilterWithinResults: "Filtriraj unutar rezultata",
      First: "Prvo",
      FirstView: "Prvi prikaz",
      Folder: "Mapa",
      ForgotPassword: "Zaboravili ste lozinku?",
      Forward: "Proslijedi",
      GetMoreRows: "Stvori više redova",
      GreaterThan: "Veće od",
      GreaterThanOrEquals: "Veće od ili jednako",
      GridSettings: "Postavke rešetke",
      GroupSelection: "Odabir grupe",
      Help: "Pomoć",
      HideColumn: "Sakrij stupac",
      IsEmpty: "Je prazno",
      IsNotEmpty: "Nije prazno",
      Last: "Posljednje",
      LastView: "Posljednji prikaz",
      LaunchActivate: "Pokreni/aktiviraj",
      LessThan: "Manje od",
      LessThanOrEquals: "Manje od ili jednako",
      Links: "Veze",
      ListTabs: "Popis svih kartica",
      LoadingItem: "Učitavanje stavke ",
      Maintenance: "Održavanje",
      Menu: "Izbornik",
      New: "Novo",
      Next: "Sljedeće",
      NextView: "Sljedeći prikaz",
      No: "Ne",
      NotChecked: "Nije provjereno",
      Notes: "Bilješke",
      NotSelected: "Nije odabrano",
      Of: " od ",
      Ok: "U redu",
      Open: "Otvori",
      Password: "Lozinka",
      Paste: "Zalijepi",
      Phone: "Telefon",
      PleaseWait: "Pričekajte",
      Previous: "Prethodno",
      PreviousView: "Prethodni prikaz",
      Print: "Ispiši",
      Queries: "Upiti",
      Redo: "Ponovi",
      Refresh: "Osvježi",
      Reject: "Odbij",
      RememberMe: "Zapamti me na ovom računalu",
      Reports: "Izvješća",
      Reset: "Vrati izvorno",
      Review: "Za pregled",
      RunFilter: "Izvedi filtar",
      RunJob: "Izvedi zadatak",
      Save: "Spremi",
      SaveBeforeClosing: "Spremi prije zatvaranja",
      SavedFilters: "Spremljeni filtri",
      SaveSubmit: "Spremi/pošalji",
      ScreenDesign: "Izgled zaslona",
      Search: "Traži",
      SelectContents: "Odaberi sadržaj",
      SelectDate: "Odaberi datum",
      SelectDeselect: "Odaberi sve/poništi odabir svega",
      Selected: "Odabrano: ",
      ServerName: "Naziv poslužitelja",
      Settings: "Postavke",
      ShowFilterRow: "Prikaži redak filtra",
      SignIn: "Prijavi se",
      SortAscending: "Sortiraj uzlazno",
      SortDescending: "Sortiraj silazno",
      Spreadsheet: "Proračunska tablica",
      StartsWith: "Započinje sa",
      StatusIndicator: "Pokazatelj statusa",
      Tasks: "Zadaci",
      Today: "Danas",
      Translate: "Prevedi",
      UserID: "Korisnički ID",
      Utilities: "Uslužni programi",
      Yes: "Da",
      Page: "Stranica",
      Rows: "Redovi",
      ShowingAll: "Prikaži sve",
      SessionNavigation: "Navigacija sesije",
      ListAllMenuItems: "Popis svih stavki izbornika",
      NoRecordsFound: "Nisu pronađeni zapisi",
      SearchTree: "Stablo pretraživanja",
      Clear: "Očisti",
      DrillDown: "Pretraži kroz razine naniže",
      Required: "Ovo je polje obavezno",
      Available: "Dostupno:",
      Add: "Dodaj",
      MoveDown: "Premjesti dolje",
      MoveUp: "Premjesti gore",
      Remove: "Ukloni",
      LastYear: "Prošle godine",
      NextMonth: "Sljedeći mjesec",
      NextWeek: "Sljedeći tjedan",
      NextYear: "Sljedeće godine",
      OneMonthAgo: "Prije mjesec dana",
      OneWeekAgo: "Prije tjedan dana",
      SixMonthsAgo: "Prije šest mjeseci",
      Time: "Vrijeme",
      CannotBeSelected: "Ovaj red nije moguće odabrati.",
      ResetToDefault: "Vrati na zadani izgled",
      CloseOtherTabs: "Zatvori ostale kartice",
      EmailValidation: "Unesite valjanu adresu e-pošte",
      UrlValidation: "Unesite valjani URL",
      EndofResults: "Kraj rezultata",
      More: "Više...",
      RecordsPerPage: "Zapisi po stranici",
      Maximize: "Povećali",
      Minimize: "Umanjiti"
    }
  });
})(this);
